let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("qFwRK")).then(() => parcelRequire('bPaYe'));